type IdentifyPayload = {
  external_id: string;
  email: string;
};

function makeRockerboxService() {
  function identify(payload: IdentifyPayload) {
    global.RB?.track('identify', payload);
  }

  function track(event: string, payload?: IdentifyPayload) {
    global.RB?.track(event, payload);
  }
  return { identify, track };
}

export { makeRockerboxService };
